var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3306V15.3306H2V8.33057C2 6.94723 2.41667 5.71807 3.25 4.64307C4.08333 3.56807 5.16667 2.8639 6.5 2.53057V1.83057C6.5 1.4139 6.64583 1.05973 6.9375 0.768066C7.22917 0.4764 7.58333 0.330566 8 0.330566C8.41667 0.330566 8.77083 0.4764 9.0625 0.768066C9.35417 1.05973 9.5 1.4139 9.5 1.83057V2.53057C10.8333 2.8639 11.9167 3.56807 12.75 4.64307C13.5833 5.71807 14 6.94723 14 8.33057V15.3306H16V17.3306H0ZM8 20.3306C7.45 20.3306 6.97917 20.1347 6.5875 19.7431C6.19583 19.3514 6 18.8806 6 18.3306H10C10 18.8806 9.80417 19.3514 9.4125 19.7431C9.02083 20.1347 8.55 20.3306 8 20.3306Z",
    fill: "#67768B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.f9f1195097e105f42444c5418e6cbc40.svg";
export { ForwardRef as ReactComponent };